import { ActionTypes as DataActionTypes, } from '../../actions/data';
import { localisedDate, localisedTimeAgo } from '../../utils/format';
import { getArticlePath } from '../../utils/routes';
export const initialState = {};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DataActionTypes.CATEGORY_TREE_HYDRATE:
        case DataActionTypes.CATEGORY_TREE_REQUEST_SUCCESS: {
            const stateAccumulator = { ...state };
            reduceCategoriesToArticles({
                accumulator: stateAccumulator,
                categories: action.payload.data.categories,
                languageId: action.payload.languageId,
                now: action.payload.now,
            });
            return stateAccumulator;
        }
        case DataActionTypes.ARTICLE_PAGE_DATA_HYDRATE:
        case DataActionTypes.ARTICLE_PAGE_DATA_REQUEST_SUCCESS:
            return articlePageResults(state, action.payload);
        case DataActionTypes.CATEGORY_PAGE_DATA_HYDRATE:
        case DataActionTypes.CATEGORY_PAGE_DATA_REQUEST_SUCCESS:
            return categoryPageResults(state, action.payload);
    }
    return state;
};
export default reducer;
function articlePageResults(state, payload) {
    var _a;
    // grab related articles
    const { data, languageId, now } = payload;
    if (!data)
        return state;
    const { article, relatedArticles } = data;
    if (!article)
        return state;
    const { parentCategory } = article.category;
    const stateAccumulator = { ...state };
    // add full article as fragment if it's missing
    stateAccumulator[article.id] = convertFullArticle({
        article,
        languageId,
        now,
    });
    // article -> categorys articles
    reduceArticleArray({
        articles: article.category.articles.results,
        categoryId: article.category.id,
        languageId,
        accumulator: stateAccumulator,
        now,
    });
    (_a = article.category.parentCategory) === null || _a === void 0 ? void 0 : _a.articles;
    relatedArticles.results.reduce((acc, a) => {
        acc[a.id] = filloutArticle({
            article: a,
            languageId,
            categoryId: a.category.id,
            now,
        });
        return acc;
    }, stateAccumulator);
    if (parentCategory) {
        reduceArticleArray({
            articles: parentCategory.articles.results,
            categoryId: parentCategory.id,
            languageId,
            accumulator: stateAccumulator,
            now,
        });
    }
    return stateAccumulator;
}
function categoryPageResults(state, payload) {
    var _a;
    const category = (_a = payload.data) === null || _a === void 0 ? void 0 : _a.category;
    if (!category)
        return state;
    const stateAccumulator = { ...state };
    const { languageId, now } = payload;
    const { parentCategory } = category;
    reduceArticleArray({
        articles: category.articles.results,
        categoryId: category.id,
        languageId,
        accumulator: stateAccumulator,
        now,
    });
    reduceCategoriesToArticles({
        categories: category.subCategories,
        languageId,
        accumulator: stateAccumulator,
        now,
    });
    if (parentCategory) {
        reduceArticleArray({
            articles: parentCategory.articles.results,
            categoryId: parentCategory.id,
            languageId,
            accumulator: stateAccumulator,
            now,
        });
    }
    return stateAccumulator;
}
// @mutates accumulator
function reduceCategoriesToArticles({ categories, accumulator, languageId, now, }) {
    categories.reduce((acc, c) => {
        reduceArticleArray({
            articles: c.articles.results,
            categoryId: c.id,
            languageId,
            accumulator: acc,
            now,
        });
        if (c.subCategories) {
            reduceCategoriesToArticles({
                categories: c.subCategories,
                accumulator: acc,
                languageId,
                now,
            });
        }
        return acc;
    }, accumulator);
}
/** @mutates accumulator */
function reduceArticleArray({ articles, categoryId, accumulator, languageId, now, }) {
    articles.reduce((acc, a) => {
        acc[a.id] = filloutArticle({ article: a, languageId, categoryId, now });
        return acc;
    }, accumulator);
}
function filloutArticle({ article, languageId, categoryId, now, }) {
    return {
        ...article,
        categoryId,
        path: getArticlePath({ languageId, slug: article.slug }),
        lastPublishedAgo: localisedTimeAgo(now, article.lastPublishedAt, languageId),
        lastPublishedAtLocal: localisedDate(article.lastPublishedAt, {
            languageId,
        }),
    };
}
function convertFullArticle({ article, languageId, now, }) {
    return {
        id: article.id,
        slug: article.slug,
        summary: article.summary,
        title: article.title,
        categoryId: article.category.id,
        path: getArticlePath({ languageId, slug: article.slug }),
        lastPublishedAt: article.lastPublishedAt,
        lastPublishedAgo: localisedTimeAgo(now, article.lastPublishedAt, languageId),
        lastPublishedAtLocal: localisedDate(article.lastPublishedAt, {
            languageId,
        }),
    };
}
//# sourceMappingURL=articleCache.js.map